import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedAccessible = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <g>
                <path
                    className={styles.cls1}
                    d="M36.45,71.08c-19.48,0-35.33-15.85-35.33-35.33S16.97,0.42,36.45,0.42s35.33,15.85,35.33,35.33
		S55.93,71.08,36.45,71.08z M36.45,4.02c-17.5,0-31.73,14.23-31.73,31.73s14.23,31.73,31.73,31.73s31.73-14.23,31.73-31.73
		S53.95,4.02,36.45,4.02z"
                />
                <g>
                    <g>
                        <path
                            className={styles.cls1}
                            d="M45.01,37.33c-5.94,0-10.77-4.83-10.77-10.77s4.83-10.77,10.77-10.77s10.77,4.83,10.77,10.77
				S50.95,37.33,45.01,37.33z M45.01,18.18c-4.62,0-8.37,3.76-8.37,8.37s3.76,8.37,8.37,8.37s8.37-3.76,8.37-8.37
				S49.62,18.18,45.01,18.18z"
                        />
                        <rect
                            x="35.44"
                            y="25.35"
                            className={styles.cls1}
                            width="19.14"
                            height="2.4"
                        />
                        <path
                            className={styles.cls1}
                            d="M45.73,37.09l-1.44-1.92c0.44-0.33,4.31-3.38,4.31-8.61c0-5.23-3.87-8.28-4.31-8.61l1.44-1.92
				C46.61,16.68,51,20.29,51,26.56C51,32.82,46.61,36.43,45.73,37.09z"
                        />
                        <path
                            className={styles.cls1}
                            d="M45.01,22.97c-1.32,0-2.62-0.2-3.86-0.59c-1.21-0.38-2.38-0.95-3.48-1.7l1.35-1.98
				c0.9,0.61,1.86,1.08,2.86,1.4c2.01,0.64,4.25,0.64,6.26,0c0.99-0.32,1.96-0.78,2.86-1.4l1.35,1.98c-1.09,0.74-2.27,1.31-3.48,1.7
				C47.63,22.77,46.33,22.97,45.01,22.97z"
                        />
                        <path
                            className={styles.cls1}
                            d="M51,34.42c-0.9-0.61-1.86-1.08-2.86-1.4c-2.02-0.64-4.25-0.64-6.26,0c-1,0.32-1.96,0.79-2.86,1.4l-1.35-1.98
				c1.09-0.74,2.26-1.31,3.48-1.7c2.49-0.79,5.22-0.79,7.71,0c1.22,0.39,2.39,0.96,3.48,1.7L51,34.42z"
                        />
                        <path
                            className={styles.cls1}
                            d="M44.29,37.09c-0.88-0.66-5.27-4.26-5.27-10.53c0-6.27,4.39-9.87,5.27-10.53l1.44,1.92
				c-0.44,0.33-4.31,3.38-4.31,8.61s3.86,8.28,4.31,8.61L44.29,37.09z"
                        />
                    </g>
                    <g>
                        <path
                            className={styles.cls1}
                            d="M47.14,51.15H20.02c-1.54,0-2.8-1.25-2.8-2.8V30.81c0-1.54,1.25-2.79,2.8-2.79h12.76v2.4H20.02
				c-0.22,0-0.4,0.18-0.4,0.39v17.55c0,0.22,0.18,0.4,0.4,0.4h27.12c0.22,0,0.39-0.18,0.39-0.4v-9.57h2.4v9.57
				C49.93,49.9,48.68,51.15,47.14,51.15z"
                        />
                        <path
                            className={styles.cls1}
                            d="M45.54,51.15H21.61c-2.42,0-4.39-1.97-4.39-4.39v-1.2h32.71v1.2C49.93,49.18,47.96,51.15,45.54,51.15z
				 M20.02,47.96c0.36,0.48,0.94,0.79,1.59,0.79h23.93c0.65,0,1.22-0.31,1.59-0.79H20.02z"
                        />
                        <rect
                            x="27.99"
                            y="51.94"
                            className={styles.cls1}
                            width="11.17"
                            height="2.4"
                        />
                        <path
                            className={styles.cls1}
                            d="M37.98,54.34H29.2v-5.59h8.78V54.34z M31.6,51.94h3.98v-0.79H31.6V51.94z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default GetStartedAccessible;
